import type { FC } from 'react'
import { Box } from '@mui/material'
import PageStateMessage from '@/components/common/PageStateMessage'

export const REPLACEMENT_HISTORY_TITLE = 'היסטוריית החלפות עדיין אינה זמינה'

/**
 * There is no Gateway endpoint for replacement history yet. The tab used to
 * read the `singleConsumersReplacement` table of the legacy browser database
 * (src/local_db), which nothing ever fills, so it always drew an empty grid as
 * if the meter had never been replaced. Say what is missing instead, and keep
 * the tab free of invented rows until the endpoint exists.
 */
export const REPLACEMENT_HISTORY_DETAIL =
  'אין כרגע ממשק בשרת להיסטוריית החלפות מדים — הנתונים יוצגו כאן לאחר שהממשק יהיה זמין'

const ConsumerHistory: FC = () => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 0,
      minHeight: 'calc(100dvh - 180px)',
      height: '100%',
    }}
  >
    <PageStateMessage
      title={REPLACEMENT_HISTORY_TITLE}
      detail={REPLACEMENT_HISTORY_DETAIL}
    />
  </Box>
)

export default ConsumerHistory
